<template>
  <div id="content-container" @click.stop="triggerModalClose()">
    <img class="img-fluid" :src="image.file" :alt="image.title" />
  </div>
</template>

<script>
  // TODO: Replace with Slider / another viewer
  // widget position:relative hack cause weird overlay issues
  import { closeModal } from 'jenesius-vue-modal';

  export default {
    props: ['image'],
    methods: {
      triggerModalClose() {
        closeModal();
      },
    },
  };
</script>

<style lang="scss" scoped>
  #content-container {
    border: 0.25em solid #f8f9fa;
  }
  .img-fluid {
    width: 100%;
    height: auto;
    max-height: 94vh;
    margin-bottom: -8px;
  }
</style>
